import Vue from 'vue';
import VueI18n from 'vue-i18n';
import moment from 'moment';

const LOCALES = {
    'en_GB': {
        moment: 'en-gb',
        translationKey: 'en_GB'
    }
};

function loadLocaleMessages (locales) {
    let translations = {};
    Object.keys(locales).forEach(locale => {
        translations[locale] = require(`./locales/${locales[locale].translationKey}.messages.json`);
    });
    return translations;
}

Vue.use(VueI18n);
moment.locale(Object.values(LOCALES).map(locale => locale.moment));

const i18n = new VueI18n({
    messages: loadLocaleMessages(LOCALES),
    locale: 'en_GB',
    fallbackLocale: 'en_GB',
    silentFallbackWarn: true
});

const i18nMixin = {
    computed: {
        language() {
            // return this.$store.getters['userModule/language'];
            return 'en_GB';
        }
    },
    watch: {
        language(language, oldLanguage) {
            if (language !== oldLanguage) {
                this.$i18n.locale = language;
                moment.locale(LOCALES[language].moment);
            }
        }
    },
    created() {
        this.$i18n.locale = this.language;
        moment.locale(LOCALES[this.language].moment);
    }
};

export default i18n;
export {
    i18n,
    i18nMixin
};
